import useSWR from "swr";
import fetcher from "@adora/shared/utils/fetch";
import { RelativeUrl } from "@adora/shared/utils/environment";
import { AdAssetGroup } from "../types/ad-asset-group";

const useAdAssetGroups = (brandId: number | null) => {
  const { data, error, isLoading, mutate } = useSWR<AdAssetGroup[]>(
    brandId ? `${RelativeUrl}/ad_asset_groups?brand_id=${brandId}` : null,
    fetcher
  );

  const getAdAssetGroup = async (adAssetGroupId: number): Promise<AdAssetGroup | null> => {
    try {
      return await fetcher<AdAssetGroup>(`${RelativeUrl}/ad_asset_groups/${adAssetGroupId}/ad_assets`);
    } catch (error) {
      console.error("Error fetching ad asset group:", error);
      return null;
    }
  };

  return {
    adAssetGroups: data,
    isLoading,
    error,
    refetchAdAssetGroups: mutate,
    getAdAssetGroup
  };
};

export default useAdAssetGroups;
